// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__L2ZA6","container_video":"styles_container_video__2SpNt","video":"styles_video__MoXh9","container_content":"styles_container_content__iE63j"};